namespace RioERP.Invoices {
    export namespace PermissionKeys {
        export const General = "Invoices:General";

        namespace InvoicesManagement {
            export const Delete = "Invoices:InvoicesManagement:Delete";
            export const Modify = "Invoices:InvoicesManagement:Modify";
            export const View = "Invoices:InvoicesManagement:View";
        }
    }
}
